import { Style } from './style';

export function combineStyle(a: Style, b: Style): Style {
  const result: Style = {};

  // Note: this is technically unsafe, because `a` and `b` may have more properties than are in `Style`.
  const keys = new Set([...Object.keys(a), ...Object.keys(b)] as (keyof Style)[]);
  keys.forEach(<K extends keyof Style>(key: K) => {
    result[key] = a[key] === b[key] ? a[key] : undefined;
  });

  return result;
}
